<template>
  <div :style="`${isPromotion ? 'padding:20px' : ''}`" class="content">
    <remark-pop ref="remarkPop"></remark-pop>
    <div style="display: flex;justify-content: flex-end">
      <el-button type="text" @click="handleRefundSet">退款说明设置</el-button>
    </div>
    <Search :hiddenExport="false" :loading="searchForm.loading" :optionsStatus="optionsStatus"
            :refundOptions="refundOptions"
            :searchForm="searchForm" :searchList="searchList"></Search>
    <!-- 表格 -->
    <dd-coupon-use-info-table :loading="searchForm.loading"
                              :order-status="searchForm.orderStatus"
                              :table-list="tableList.list"
                              @refreshData="getList"></dd-coupon-use-info-table>
    <!-- 分页 -->
    <el-pagination
      v-if="tableList.total > 0"
      :current-page="searchForm.pageNo"
      :page-size="tableList.pageSize"
      :page-sizes="[10, 20, 30, 40]"
      :total="tableList.total"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import Search from "@/components/Search";
import mini from "@/api/mini";
import DdCouponUseInfoTable from "./ddCouponUseInfoTable.vue";
import RemarkPop from "./remarkPop.vue";

const MiniModel = new mini()

export default {
  name: "ddCouponUseInfo",
  components: {
    DdCouponUseInfoTable,
    Search,
    RemarkPop
  },
  data() {
    return {
      couponPlatformType:'80',
      activeName: '0',
      searchForm: {
        code: '',
        couponName: '',
        status: '',
        tbOrderId: '',
        useTime: [],
        thirdOrderId: '',
        orderId: '',
        refundStatus: '',
        operateBeginTime: '',
        operateEndTime: '',
        startCreateTime: '',
        endCreateTime: '',
        useTimeStart: '',
        useTimeEnd: '',
        douYinId: '',
        time: [],
        loading: true,
        pageSize: 10,
        pageNo: 1,
        thirdBuyer: '',
      },
      searchList: [
        {
          id: 'thirdOrderId',
          text: 'POI单号',
          placeholder: 'POI单号',
          type: 'input',
          width: '240px'
        },
        {
          id: 'code',
          text: '核销券码',
          placeholder: '核销券码',
          type: 'input'
        },
        {
          id: 'couponName',
          text: '优惠券名称',
          placeholder: '优惠券名称',
          type: 'input'
        },
        {
          id: 'thirdProductId',
          text: '商品ID',
          placeholder: '商品ID',
          type: 'input'
        },
        {
          id: 'status',
          text: '使用状态',
          placeholder: '使用状态',
          type: 'select',
        },
        {
          // 操作时间
          id: 'useTime',
          text: '用券时间',
          type: 'useTime'
        },
        {
          // 达人抖音号
          id: 'douYinId',
          text: '达人抖音号',
          type: 'input',
          placeholder: '多个用逗号隔开',
        },
        {
          // 操作时间
          id: 'time',
          text: '领券时间',
          type: 'time'
        },
        // {
        //   id: 'thirdOrderId',
        //   text: '抖店商品券订单号',
        //   placeholder: '抖店商品券订单号',
        //   type: 'input'
        // },
        {
          id: 'orderId',
          text: '用券影票订单号',
          placeholder: '用券影票订单号',
          type: 'input'
        },
        {
          id: 'refundStatus',
          text: '退款状态',
          placeholder: '退款状态',
          type: 'select',
        },
        {
          id: 'thirdBuyer',
          text: '用户ID',
          placeholder: '用户ID',
          type: 'input'
        },
      ],
      tableList: {
        list: [],
        total: 0,
        pageSize: 10
      },
      // 优惠券状态： 0待使用 1已使用 2已核销
      optionsStatus: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '待使用',
          value: '0'
        },
        {
          label: '已使用',
          value: '1'
        },
        {
          label: '已核销',
          value: '2'
        }
      ],
      currentPage: 1,
      refundOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未退款',
          value: '0'
        },
        {
          label: '已退款',
          value: '1'
        },
      ],
      isPromotion: false,
    }
  },

  mounted() {
    // operateTime 需要给一个默认值 给最近7天
    this.lastSevenDays()
    this.getList()
    // 获取hash值
    this.isPromotion = window.location.hash.includes('promotion')

  },
  methods: {
    handleRefundSet(){
      this.$refs.remarkPop.open();
    },
    //最近7天
    lastSevenDays() {
      const now = new Date()

      // 设置结束时间为当天的 23:59:59
      const endDate = new Date(now)
      endDate.setHours(23, 59, 59, 999)

      // 设置开始时间为7天前的 00:00:00
      const startDate = new Date(endDate)
      startDate.setDate(endDate.getDate() - 6) // 包含今天共7天
      startDate.setHours(0, 0, 0, 0)

      this.searchForm.time = [
        this.formatDate(startDate),
        this.formatDate(endDate)
      ]
      this.searchForm.startCreateTime = this.formatDate(startDate)
      this.searchForm.endCreateTime = this.formatDate(endDate)
    },
    // 格式化日期
    formatDate(date) {
      const padZero = (n) => (n < 10 ? '0' + n : n)

      const year = date.getFullYear()
      const month = padZero(date.getMonth() + 1)
      const day = padZero(date.getDate())

      const hours = padZero(date.getHours())
      const minutes = padZero(date.getMinutes())
      const seconds = padZero(date.getSeconds())

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 导出
    exportButton() {
      MiniModel.couponExportV3Market({
        ...this.searchForm,
        miniAppKey: localStorage.getItem("appKeyMini"),
        miniAppType: 80,
        createTimeEnd: this.searchForm.endCreateTime,
        createTimeStart: this.searchForm.startCreateTime,
        couponPlatformType: this.couponPlatformType,
      }).then(async res => {
        console.log(res)
        const code = res.data.code
        const message = res.data.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
      })
    },
    getList(flag) {
      if (flag === 'reset') {
        this.lastSevenDays()
      }
      this.searchForm.loading = true
      MiniModel.couponSearchMarket({
        ...this.searchForm,
        miniAppKey: localStorage.getItem("appKeyMini"),
        // miniAppType: 80,
        createTimeEnd: this.searchForm.endCreateTime,
        createTimeStart: this.searchForm.startCreateTime,
        couponPlatformType: this.couponPlatformType,
      }).then(res => {
        if (res.data.code === 200) {
          this.tableList = res.data.data
        } else {
          this.$message.error(res.data.info)
        }
      }).finally(() => {
        this.searchForm.loading = false
      })
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getList();
    },
  }
}
</script>
<style>
.el-icon-circle-close {
  color: red;
}

</style>
<style lang="less" scoped>

.content {
  background: #FFFFFF;
  border-radius: 8px;

  .title {
    font-size: 20px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponDyPoiNew/component/couponDyPoiDetail.vue